(() => {
  const init = () => {
    const control = document.querySelector('bh3d-range-view[data-army-url]');
    const original = document.querySelector('bh3d-full-listings')?.closest('.shopify-section') || document.querySelector('#filter-results')?.closest('.shopify-section');
    if (!control || !original || control.dataset.listingsReady) return;
    control.dataset.listingsReady = 'true';
    original.setAttribute('data-bh3d-original-listings', '');
    const mount = document.createElement('div');
    mount.className = 'bh3d-scoped-listings cc-product-card-grid';
    mount.hidden = true;
    original.after(mount);
    let request;
    let activeKey;
    const message = (text, source) => {
      const section = document.createElement('section');
      section.className = 'container bh3d-scope-grid';
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      status.textContent = text;
      section.append(status);
      if (source) {
        const link = document.createElement('a');
        link.href = source + '#products-toolbar';
        link.textContent = control.dataset.open;
        section.append(link);
      }
      mount.replaceChildren(section);
    };
    const update = async () => {
      const params = new URL(location.href).searchParams;
      const view = params.get('range_view');
      const page = Math.max(1, Number.parseInt(params.get('range_page'), 10) || 1);
      const key = (view || 'all') + ':' + page;
      if (activeKey === key) return;
      activeKey = key;
      request?.abort();
      if (!['armies', 'individual'].includes(view)) {
        original.hidden = false;
        mount.hidden = true;
        mount.replaceChildren();
        return;
      }
      original.hidden = true;
      mount.hidden = false;
      const source = view === 'armies' ? control.dataset.armyUrl : control.dataset.individualUrl;
      if (!source) {
        message(control.dataset.empty);
        return;
      }
      request = new AbortController();
      const currentRequest = request;
      mount.setAttribute('aria-busy', 'true');
      message(control.dataset.loading);
      try {
        const url = new URL(source, location.origin);
        url.searchParams.set('section_id', 'bh3d-scoped-listings');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { signal: currentRequest.signal });
        if (!response.ok) throw new Error('Listings request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-bh3d-scope-content]');
        if (!content) throw new Error('Listings section missing');
        if (currentRequest.signal.aborted) return;
        mount.replaceChildren(content);
        mount.querySelectorAll('.pagination a[href]').forEach(link => {
          const destination = new URL(link.getAttribute('href'), location.origin);
          const targetPage = destination.searchParams.get('page') || '1';
          const pageUrl = new URL(location.href);
          pageUrl.searchParams.set('range_view', view);
          pageUrl.searchParams.set('range_page', targetPage);
          pageUrl.hash = 'scoped-listings';
          link.href = pageUrl.pathname + pageUrl.search + pageUrl.hash;
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          activeKey = null;
          message(control.dataset.error, source);
        }
      } finally {
        if (request === currentRequest) mount.removeAttribute('aria-busy');
      }
    };
    mount.addEventListener('click', event => {
      const link = event.target.closest('.pagination a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.pushState(history.state, '', link.href);
      update().then(() => mount.scrollIntoView({ block: 'start' }));
    });
    window.addEventListener('bh3d:range-view', update);
    window.addEventListener('popstate', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
